const upperCaseAtIndex = (string: string, index = 1) => string[index].toUpperCase();

const camelCase = (string: string) =>
  string.replace(/-([a-z])/g, (matchedChar) => upperCaseAtIndex(matchedChar));

export default camelCase;
